import Tab from '@/types/Tab'

export default function (id) {
	return [
		new Tab('crawlers', {
			to: { name: 'market-airbnb-crawlers' },
			name: 'Crawlers',
			value: `/marketairbnb/${id}/crawlers`,
		}),
		new Tab('listings', {
			to: { name: 'market-airbnb-listings' },
			name: 'Listings',
			value: `/marketairbnb/${id}/listings`,
		}),
	]
}
